export default __webpack_public_path__ + "static/media/success.d639b7bb.svg";